import { Button, Form, Grid, Header, Segment } from '@mairistem/composants';
import React from 'react';

import type { ElementDisponibleType } from '@/types';

import Editor, { type EditorHandle } from './Editor';
import ElementsDisponibles from './ElementsDisponibles';

import './EditeurMail.css';

type EditeurMailProps = {
  htmlDefaut: string;
  htmlInitial: string;
  elements: ElementDisponibleType[];
  loading?: boolean;
  onChange?: (html: string, modifie: boolean) => void;
};

const EditeurMail = (props: EditeurMailProps) => {
  const { htmlDefaut, htmlInitial, elements, loading = false, onChange } = props;

  const htmlInitialRef = React.useRef(htmlInitial);
  const editorHandleRef = React.useRef<EditorHandle | null>(null);

  const handleEditorReady = React.useCallback((handle: EditorHandle) => {
    editorHandleRef.current = handle;
  }, []);

  const handleChange = React.useCallback(
    (value: string) => {
      onChange?.(value, value !== htmlInitialRef.current);
    },
    [onChange],
  );

  const handleRetourDefaut = React.useCallback(() => {
    editorHandleRef.current?.setContent(htmlDefaut);
    onChange?.(htmlDefaut, htmlDefaut !== htmlInitialRef.current);
  }, [htmlDefaut, onChange]);

  const handleInsererElement = React.useCallback((valeur: string) => {
    editorHandleRef.current?.insertText(valeur);
  }, []);

  return (
    <Grid as={Form} className="editeur-mail">
      <Grid.Column width={11}>
        <Segment basic style={{ padding: 0 }}>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              marginBottom: '1em',
              height: 30,
            }}
          >
            <Header as="h4" style={{ margin: 0 }}>
              Éditeur du contenu
            </Header>
            <Button
              data-testid="button-retour-defaut"
              basic
              size="tiny"
              icon="undo"
              content="Revenir au modèle par défaut"
              onClick={handleRetourDefaut}
              disabled={loading}
              floated="right"
            />
          </div>
          <Editor
            value={htmlInitial}
            onChange={handleChange}
            onReady={handleEditorReady}
            disabled={loading}
          />
        </Segment>
      </Grid.Column>
      <Grid.Column width={5}>
        <ElementsDisponibles elements={elements} onInsererElement={handleInsererElement} />
      </Grid.Column>
    </Grid>
  );
};

export default EditeurMail;
